import { ComponentChildren } from 'preact';
import { IcoChevronDown } from '@components/icons';

type SettingsButtonProps = {
  label: string;
  onClick: () => void;
  icon: ComponentChildren;
  className?: string;
};

/**
 * A reusable settings button component with consistent styling
 */
export function SettingsButton({ label, onClick, icon, className = '' }: SettingsButtonProps) {
  return (
    <button
      class={`w-full p-3 text-left rounded-lg border border-gray-200 hover:bg-gray-50 flex items-center justify-between ${className}`}
      onClick={onClick}
    >
      <span class="flex items-center">
        <span class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-3">
          {icon}
        </span>
        {label}
      </span>
      <IcoChevronDown class="w-4 h-4 opacity-75" />
    </button>
  );
}
